// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ninput[type=date][data-v-1786d93a] {\n  min-width: 120px;\n}\n.relative-amount[data-v-1786d93a] {\n  max-width: 70px;\n}\n", ""]);
// Exports
module.exports = exports;
